import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";
import { Description } from "../../../components/Description";
import styles from "../../../components/ListDescriptions/styles.module.css";



import { formatarParaMoedaBRL, formatarCNPJ } from "../../../utils";

export default function GPS({
  gps
}: {
  gps: any
}) {
  const { t } = useTranslation();

  const valorBodyTemplate = (rowData: any) => {
    if (rowData.VALOR.includes('R$')) {
      return rowData.VALOR;
    }
    const valor = rowData.VALOR ? parseFloat(rowData.VALOR.replace(/\./g, '').replace(',', '.')) : 0;
    return formatarParaMoedaBRL(valor);
  };


  const headerTemplateProtesto = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {gps.PROTESTOS && gps.PROTESTOS.OCORRENCIAS && gps.PROTESTOS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span>)}</div>;
  }

  const headerTemplatePendencia = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {gps.PEND_FINANCEIRAS && gps.PEND_FINANCEIRAS.OCORRENCIAS && gps.PEND_FINANCEIRAS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('restricaoMercado')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('restricaoMercado')}</span>)}</div>;
  }
  const getResumoProtesto = () => {
    const resumos: any[] = [];
    if (gps?.PROTESTOS && gps?.PROTESTOS?.OCORRENCIAS && gps?.PROTESTOS?.OCORRENCIAS.length > 0) {
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Protestos',
        value: gps?.PROTESTOS?.QUANTIDADE_OCORRENCIA
      })
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Data Ultimo Protesto',
        value: gps?.PROTESTOS?.ULTIMO_PROTESTO
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Protestos',
        value: 0
      })
      let valorTotal = 0.0
      gps?.PROTESTOS?.OCORRENCIAS.forEach((prot: any) => {
        valorTotal = valorTotal + Number(prot.VALOR.replace('.', '').replace(',', '.'))
      });
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }

    return resumos;
  }



  const ocorrenciasRestricoes = gps.INFORMACOES_ALERTAS_RESTRICOES?.OCORRENCIAS || [];
  const rgItem = ocorrenciasRestricoes.find((item: any) => item.TITULO === 'RG');
  const pisItem = ocorrenciasRestricoes.find((item: any) => item.TITULO === 'NUMERO PIS');
  const filteredOcorrenciasRestricoes = ocorrenciasRestricoes.filter((item: any) => item.TITULO !== 'RG' && item.TITULO !== 'NUMERO PIS');

  return (
    <div>
      {gps.mensagemErro ? (<p>{gps.mensagemErro}</p>) :
        (<div>
          {gps.DADOS_RECEITA_FEDERAL && (
            <Panel header={t('Dados Receita Federal')}>
              <div className={styles.wrapper}>
                <div className={styles.gridContainer} style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                  <Description label={t('Nome')} value={gps.DADOS_RECEITA_FEDERAL.NOME} />
                  <Description label={t('Data Nascimento/Fundação')} value={gps.DADOS_RECEITA_FEDERAL.DATA_NASCIMENTO_FUNDACAO} />
                  <Description label={t('Situação Receita')} value={gps.DADOS_RECEITA_FEDERAL.SITUACAO_RECEITA} />
                  <Description label={t('Data Atualização')} value={gps.DADOS_RECEITA_FEDERAL.DATA_ATUALIZACAO} />
                  <Description label={t('Sexo')} value={gps.DADOS_RECEITA_FEDERAL.SEXO} />
                  <Description label={t('Nome da Mãe')} value={gps.DADOS_RECEITA_FEDERAL.NOME_MAE} />
                </div>
              </div>
            </Panel>
          )}
          <br />
          {gps.PARENTES && gps.PARENTES.INFOCONTATOS && gps.PARENTES.INFOCONTATOS.length > 0 && (
            <Panel header={t('Parentes')}>
              <DataTable className="mobile-text-left" size="small" value={gps.PARENTES.INFOCONTATOS} responsiveLayout="stack" breakpoint="960px">
                <Column field="NOME" header={t('Nome')}></Column>
                <Column field="RELACAO" header={t('Relação')}></Column>
                <Column field="NASCIMENTO" header={t('Data Nascimento')}></Column>
                <Column field="DOCUMENTO" header={t('Documento')}></Column>
                <Column field="TIPO_PESSOA" header={t('Tipo Pessoa')}></Column>
              </DataTable>
            </Panel>
          )}
          <br />

          {ocorrenciasRestricoes.length > 0 && (
            <Panel header={t('Informações, Alertas e Restrições')}>
              <div className={styles.wrapper}>
                <div className={styles.gridContainer} style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                  {rgItem && <Description label={t('RG')} value={rgItem.OBSERVACOES} />}
                  {pisItem && <Description label={t('PIS')} value={pisItem.OBSERVACOES} />}
                </div>
              </div>
              {filteredOcorrenciasRestricoes.length > 0 ? (
                <DataTable className="mobile-text-left" size="small" value={filteredOcorrenciasRestricoes} responsiveLayout="stack" breakpoint="960px">
                  <Column field="TITULO" header={t('Título')}></Column>
                  <Column field="OBSERVACOES" header={t('Observações')}></Column>
                  <Column field="DESCRICAO_TIPO_INFORMACAO" header={t('Tipo')}></Column>
                </DataTable>
              ) : (
                <p
                  style={{
                    textAlign: "center",
                    padding: "10px",
                    fontStyle: "italic",
                    color: "#666",
                  }}
                >
                  Não há registros na base consultada.
                </p>
              )}
            </Panel>
          )}
          <br />
          {gps.SOMENTE_ENDERECO && gps.SOMENTE_ENDERECO.DADOS && (
            <div>
              <Panel header={t('enderecos')}>
                <DataTable size="small" value={gps.SOMENTE_ENDERECO.DADOS} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="ENDERECO" header={t('logradouro')}></Column>
                  <Column field="BAIRRO" header={t('bairro')}></Column>
                  <Column field="NUMERO" header={t('numero')}></Column>
                  <Column field="COMPLEMENTO" header={t('complemento')}></Column>
                  <Column field="CIDADE" header={t('cidade')}></Column>
                  <Column field="UF" header={t('uf')}></Column>
                  <Column field="CEP" header={t('cep')}></Column>
                </DataTable>

              </Panel>
              <br></br>
            </div>
          )}
          <br />
          {gps.TELEFONE_FIXO && gps.TELEFONE_FIXO.TELEFONES && (
            <div>
              <Panel header={t('fone')}>
                <DataTable size="small" value={gps.TELEFONE_FIXO.TELEFONES} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="NUM_TELEFONE" header={t('fone')} body={(rowData) => `(${rowData.DDD}) ${rowData.NUM_TELEFONE.replace(/^(\d{4})(\d{4})$/, "$1-$2")}`}></Column>
                </DataTable>

              </Panel>
              <br></br>
            </div>
          )}
          <br />
          {gps.TELEFONE_CELULAR && gps.TELEFONE_CELULAR.TELEFONES && (
            <div>
              <Panel header={t('celular')}>
                <DataTable size="small" value={gps.TELEFONE_CELULAR.TELEFONES} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="NUM_TELEFONE" header={t('fone')} body={(rowData) => `(${rowData.DDD}) ${rowData.NUM_TELEFONE.replace(/^(\d{1})(\d{4})(\d{4})$/, "$1 $2-$3")}`}></Column>
                </DataTable>

              </Panel>
              <br></br>
            </div>
          )}
          <br />
          {gps.EMAILS && gps.EMAILS.INFOEMAILS && (
            <div>
              <Panel header={t('email')}>
                <DataTable size="small" value={gps.EMAILS.INFOEMAILS} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="ENDERECO" header={t('email')}></Column>
                </DataTable>

              </Panel>
              <br></br>
            </div>
          )}
          <br />
          {gps.CH_SEM_FUNDOS_BACEN && (
            <Panel header="Cheques sem Fundos (BACEN)" className="panel-header-azul" toggleable={true}>
              {Number(gps.CH_SEM_FUNDOS_BACEN?.QUANTIDADE_OCORRENCIA) > 0 ? (
                <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "5px 15px" }}>
                  <div>
                    <Description label="Quantidade Ocorrências" value={gps.CH_SEM_FUNDOS_BACEN?.QUANTIDADE_OCORRENCIA} />
                    <Description label="Correntista" value={gps.CH_SEM_FUNDOS_BACEN?.CORRENTISTA} />
                  </div>
                  <div>
                    <Description label="CPF/CNPJ" value={gps.CH_SEM_FUNDOS_BACEN?.CPFCNPJ} />
                    <Description label="Tipo de Pessoa" value={gps.CH_SEM_FUNDOS_BACEN?.TIPO_PESSOA} />
                  </div>
                </section>
              ) : (
                <NadaConsta />
              )}
            </Panel>
          )}
          <br />
          {gps.RENDA_PRESUMIDA && (
            <Panel header={t('Renda Presumida')}>
              <div className={styles.wrapper}>
                <div className={styles.gridContainer} style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                  <Description label={t('Faixa')} value={gps.RENDA_PRESUMIDA.FAIXA} />
                  <Description label={t('Mensagem')} value={gps.RENDA_PRESUMIDA.MENSAGEM} />
                  <Description label={t('Descrição')} value={gps.RENDA_PRESUMIDA.DESCRICAO} />
                </div>
              </div>
            </Panel>
          )}
          <br />
          {gps.VEICULOS_POR_DOCUMENTO && gps.VEICULOS_POR_DOCUMENTO.OCORRENCIAS && gps.VEICULOS_POR_DOCUMENTO.OCORRENCIAS.length > 0 && (
            <Panel header={t('Veículos por Documento')}>
              <DataTable className="mobile-text-left" size="small" value={gps.VEICULOS_POR_DOCUMENTO.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
                <Column field="MARCA_MODELO" header={t('Marca/Modelo')}></Column>
                <Column field="PLACA" header={t('Placa')}></Column>
                <Column field="ANO_MODELO" header={t('Ano Modelo')}></Column>
                <Column field="COR" header={t('Cor')}></Column>
                <Column field="SITUACAO" header={t('Situação')}></Column>
              </DataTable>
            </Panel>
          )}
          <br />
          {gps.PARTICIPACAO_EM_EMPRESAS && gps.PARTICIPACAO_EM_EMPRESAS.OCORRENCIAS && gps.PARTICIPACAO_EM_EMPRESAS.OCORRENCIAS.length > 0 && (
            <Panel header={t('Participação em Empresas')}>
              <DataTable className="mobile-text-left" size="small" value={gps.PARTICIPACAO_EM_EMPRESAS.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
                <Column field="RAZAO_SOCIAL" header={t('Razão Social')}></Column>
                <Column field="CNPJ" header={t('CNPJ')} body={(rowData) => formatarCNPJ(rowData.CNPJ)}></Column>
                <Column field="PARTICIPACAO" header={t('Participação (%)')}></Column>
                <Column field="PARTICIPANTE_CARGO" header={t('Cargo')}></Column>
              </DataTable>
            </Panel>
          )}
          {/* Removido conforme solicitação do cliente em 23/04/2026, chamado 334 */}
          {/* <Panel headerTemplate={headerTemplateProtesto}>
            {gps.PROTESTOS?.OCORRENCIAS?.length === 0 ? (<NadaConsta />) : (<>
              <div className="flex-consulta  flex-wrap gap-3">
                {getResumoProtesto().map((item: any, index: number) => (

                  <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
                    <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                        <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                        <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                        <i className={item.icon} />
                      </span>
                    </div>
                  </Card>

                ))}
              </div>
              <br></br>
              <DataTable size="small" value={gps.PROTESTOS?.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
                <Column field="DATA_OCORRENCIA" header={t('data')}></Column>
                <Column field="CARTORIO" header={t('cartorio')}></Column>
                <Column field="COMARCA" header={t('cidade')}></Column>
                <Column field="UF" header={t('uf')}></Column>
                <Column field="VALOR" header={t('valor')}></Column>
              </DataTable>
            </>)}
          </Panel> */}
          <br />
          <Panel headerTemplate={headerTemplatePendencia}>
            {!gps.PEND_FINANCEIRAS || !gps.PEND_FINANCEIRAS.OCORRENCIAS || gps.PEND_FINANCEIRAS.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (() => {
              const ocorrencias = gps.PEND_FINANCEIRAS.OCORRENCIAS;
              const parseValor = (v: any) => {
                if (typeof v === 'number') return v;
                if (typeof v === 'string') {
                  const clean = v.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
                  return parseFloat(clean) || 0;
                }
                return 0;
              };
              const sortedByDate = [...ocorrencias].sort((a: any, b: any) => {
                const dateA = a.DATA_INCLUSAO ? a.DATA_INCLUSAO.split('/').reverse().join('-') : '';
                const dateB = b.DATA_INCLUSAO ? b.DATA_INCLUSAO.split('/').reverse().join('-') : '';
                return dateA.localeCompare(dateB);
              });
              const primeiro = sortedByDate[0]?.DATA_INCLUSAO || '-';

              return (
                <div className="flex flex-column gap-4">
                  <div className="surface-100 border-round">
                    <div className="font-bold text-lg p-3 surface-200 text-700 uppercase mb-3">RESUMO</div>
                    <div className="grid p-3">
                      <div className="col-12 md:col-6">
                        <div className="mb-2"><strong className="mr-2">QUANTIDADE:</strong> {gps.PEND_FINANCEIRAS.QUANTIDADE_OCORRENCIA}</div>
                        <div className="mb-2"><strong className="mr-2">VALOR TOTAL:</strong> {formatarParaMoedaBRL(parseValor(gps.PEND_FINANCEIRAS.VALOR_TOTAL))}</div>
                      </div>
                      <div className="col-12 md:col-6">
                        <div className="mb-2 text-right"><strong className="mr-2">PRIMEIRO:</strong> {primeiro}</div>
                      </div>
                    </div>
                  </div>

                  <DataTable className="mobile-text-left" size="small" value={ocorrencias} responsiveLayout="stack" breakpoint="960px">
                    <Column field="DATA_INCLUSAO" header={t('data')}></Column>
                    <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
                    <Column field="CONTRATO" header={t('contrato')}></Column>
                    <Column field="CREDOR" header={t('informante')}></Column>
                    <Column field="VALOR" header={t('valor')} body={valorBodyTemplate}></Column>
                  </DataTable>
                </div>
              );
            })()}
          </Panel>
          <br />
        </div>)}
    </div>
  )
}
